import { actionBuilder } from '../../functions/redux';
import * as TYPE from './types';

export const loginLineRequest = actionBuilder(TYPE.AUTHEN_LOGIN_LINE_REQ);
export const loginLineSuccess = actionBuilder(TYPE.AUTHEN_LOGIN_LINE_SUCCESS);
export const loginLineFail = actionBuilder(TYPE.AUTHEN_LOGIN_LINE_FAIL);
